// IdleTimerProvider.jsx - Version simplifiée et corrigée
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { IdleTimerContext } from './IdleTimerContext';

export const IdleTimerProvider = ({ children, timeoutMinutes = 5, onTimeout }) => {
  const [isIdle, setIsIdle] = useState(false);
  const timerRef = useRef(null);
  const lastActivityRef = useRef(0);
  const isIdleRef = useRef(false);

  // ✅ Fonction pour réinitialiser le timer (sans setState)
  const startTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    
    timerRef.current = setTimeout(() => {
      const now = Date.now();
      const idleTime = (now - lastActivityRef.current) / 1000 / 60;
      if (idleTime >= timeoutMinutes && !isIdleRef.current) {
        isIdleRef.current = true;
        setIsIdle(true);
        onTimeout?.();
      }
    }, timeoutMinutes * 60 * 1000);
  }, [timeoutMinutes, onTimeout]);

  // ✅ Réinitialiser avec mise à jour de l'activité
  const resetTimer = useCallback(() => {
    lastActivityRef.current = Date.now();
    isIdleRef.current = false;
    if (isIdle) {
      setIsIdle(false);
    }
    startTimer();
  }, [isIdle, startTimer]);

  // ✅ Initialisation au montage
  useEffect(() => {
    lastActivityRef.current = Date.now();
    startTimer();
    
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [startTimer]);

  // ✅ Écoute des événements utilisateur
  useEffect(() => {
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click', 'mousemove'];
    
    const handleActivity = () => {
      resetTimer();
    };

    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    return () => {
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [resetTimer]);

  return (
    <IdleTimerContext.Provider value={{ isIdle, resetTimer }}>
      {children}
    </IdleTimerContext.Provider>
  );
};